import "./styles.scss";
import { useEffect, useRef, useState } from "react";
import { finalCta, journeySteps, midCta } from "./data";
import { HeroSection } from "./sections/HeroSection";
import { JourneySection } from "./sections/JourneySection";
import { MatchingSection } from "./sections/MatchingSection";
import { PillarsSection } from "./sections/PillarsSection";
import { CompatibilitySection } from "./sections/CompatibilitySection";
import { MatchCtaSection } from "./sections/MatchCtaSection";
import { PersonalitySection } from "./sections/PersonalitySection";
import { TestimonialsSection } from "./sections/TestimonialsSection";

export const SmartGuildLandingPage = () => {
  const [activePillar, setActivePillar] = useState(0);
  const [journeyStep, setJourneyStep] = useState(0);
  const howItWorksRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setJourneyStep((prev) => (prev + 1) % journeySteps.length);
    }, 2500);

    return () => window.clearInterval(timer);
  }, []);

  const scrollToHowItWorks = () => {
    howItWorksRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="smart-guild-landing">
      <HeroSection onScrollToHowItWorks={scrollToHowItWorks} />
      <JourneySection journeyStep={journeyStep} />
      <PillarsSection
        activePillar={activePillar}
        onSelect={setActivePillar}
      />
      <MatchingSection sectionRef={howItWorksRef} />
      <CompatibilitySection />
      <MatchCtaSection
        title={midCta.title}
        subtitle={midCta.subtitle}
        className="sg-cta--decor"
      />
      <PersonalitySection />
      <TestimonialsSection />
      <MatchCtaSection
        title={finalCta.title}
        subtitle={finalCta.subtitle}
        className="sg-cta--tight"
      />
    </div>
  );
};
